import type { SubmitClaimReversalRequest } from '@quromedical/healthbridge/client';

import type { CreateClaimReversal } from './schema';

// the `.` indicates where the milliseconds start, we want everything before that
const asHealthbridgeDateTime = (date: string) =>
  new Date(date).toISOString().split('.')[0];

const pmaName = 'Insight' as const;
const pmaVersion = '1' as const;
const bonitasRoutingCode = '91982';

export const mapClaimReversalToHBFormat = (
  claimReversal: CreateClaimReversal,
): SubmitClaimReversalRequest => {
  return {
    ProviderMessage: {
      Reversal: {
        Transaction: {
          DataSet: '01',
          InvoiceNum: claimReversal.invoiceNumber,
          PMAName: pmaName,
          PMAVersion: pmaVersion,
          RoutingCode: bonitasRoutingCode,
          SavedDateTime: asHealthbridgeDateTime(new Date().toISOString()),
        },
      },
    },
  };
};
